import { NgModule } from '@angular/core';
import { SearchComponents } from '@core/const';
import { ConfigModule } from '@spartacus/core';

@NgModule({
  imports: [
    ConfigModule.withConfig({
      featureModules: {
        SearchBox: {
          module: () => import('./custom-searchbox').then((m) => m.SdvorCustomSearchBoxModule),
          cmsComponents: [SearchComponents.SearchBoxComponent],
        },
      },
    }),
  ],
})
export class SdvorSearchUiLazyModule {}
